import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <img src="/LandingPageAssets/Logos/jk-logo-full-300.png" alt="J&K Realty" className="footer-logo" width="300" height="68" loading="lazy" />
              <h3>J&K Realty</h3>
              <p>Donde tus sueños encuentran el espacio perfecto.<br />Espacios que abrazan tu estilo de vida.</p>
              <div className="footer-social">
                <a href="https://www.instagram.com/jk_realty_uio/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Enlaces Rápidos</h4>
              <ul>
                <li><a href="/#home">Inicio</a></li>
                <li><a href="/#about">Acerca de</a></li>
                <li><a href="/#services">Servicios</a></li>
                <li><Link to="/propiedades">Propiedades</Link></li>
                <li><a href="/#contact">Contacto</a></li>
              </ul>
            </div>

            <div className="footer-services">
              <h4>Servicios</h4>
              <ul>
                <li><a href="/#services">Compra de Casas</a></li>
                <li><a href="/#services">Venta de Casas</a></li>
                <li><a href="/#services">Terrenos y Lotes</a></li>
                <li><a href="/#services">Bienes Raíces Comerciales</a></li>
              </ul>
            </div>

            <div className="footer-contact">
              <h4>Ponte en Contacto</h4>
              <div className="footer-contact-item">
                <strong>Teléfono:</strong>
                <a href="tel:+593995410584">+593 99 541 0584</a>
              </div>
              <div className="footer-contact-item">
                <strong>WhatsApp:</strong>
                <a href="https://wa.me/593995410584" target="_blank" rel="noopener noreferrer">Enviar Mensaje</a>
              </div>
              <div className="footer-contact-item">
                <strong>Instagram:</strong>
                <a href="https://www.instagram.com/jk_realty_uio/" target="_blank" rel="noopener noreferrer">@jk_realty_uio</a>
              </div>
              <div className="footer-contact-item">
                <strong>Email:</strong>
                <a href="mailto:karen@jkrealty.ec">karen@jkrealty.ec</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-brand-image">
          <img src="/LandingPageAssets/Logos/jk-logo-full-600.png" alt="J&K Realty" className="footer-brand-img" width="600" height="136" loading="lazy" />
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              {`© ${currentYear} J&K Realty. Todos los derechos reservados.`}
            </p>
            <div className="footer-legal">
              <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacyPolicy(true); }}>Política de Privacidad</a>
            </div>
          </div>
          <div className="footer-disclaimer">
            <p>
              La información proporcionada en este sitio web es solo para fines informativos y no constituye
              asesoramiento legal o financiero. Todas las propiedades están sujetas a venta previa, cambio o retiro.
              Profesional Inmobiliaria Licenciada.
            </p>
          </div>
        </div>
      </div>

      <PrivacyPolicy
        isOpen={showPrivacyPolicy}
        onClose={() => setShowPrivacyPolicy(false)}
      />
    </footer>
  );
};

export default Footer;
